import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { PillType } from '../../../shared/components/pill/pill.model';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';
import { ViCarePlan } from '@vi-iot/client/index';
import { InstallationDetailsStore } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-vicare-plans',
  templateUrl: './vicare-plans.component.html',
  styleUrls: ['./vicare-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViCarePlansComponent implements OnInit, OnDestroy {
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  plans: ViCarePlan[];
  readonly pillType = PillType;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(protected installationDetailsStore: InstallationDetailsStore) {}

  ngOnInit(): void {
    this.installationDetailsStore.vicarePlans$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((planList) => {
        if (planList?.length > 0) {
          this.plans = planList.filter((plan) => !plan.isDefault);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
